export default "__VITE_ASSET__D9lew0tH__"